export const VENTAS_LISTA_TODOS = 'PPTCVENTLIST0001'
export const VENTAS_EDITAR_TODOS = 'PPTCVENTNUEV0002'
export const ENVIO_SUNAT = 'PPTCEMDOMAIN0003'
export const VENTAS_EDITAR_CORRELATIVO = 'PPTCVENTNUEV0004'
export const VENTAS_ELIMINAR = 'PPTCVENTLIST0005'
export const VENTAS_ELIMINAR_TODOS = 'PPTCVENTLIST0006'

export const ORDENESCOMPRAS_FIRMAR = 'PPTCORCONUEV0001'

export const __dictionary = {
  [ORDENESCOMPRAS_FIRMAR]: {
    id: ORDENESCOMPRAS_FIRMAR,
    nombre: 'ORDENESCOMPRAS_FIRMAR'
  },
  [VENTAS_LISTA_TODOS]: {
    id: VENTAS_LISTA_TODOS,
    nombre: 'VENTAS_LISTA_TODOS'
  },
  [VENTAS_EDITAR_TODOS]: {
    id: VENTAS_EDITAR_TODOS,
    nombre: 'VENTAS_EDITAR_TODOS'
  },
  [ENVIO_SUNAT]: {
    id: ENVIO_SUNAT,
    nombre: 'ENVIO_SUNAT'
  },
  [VENTAS_EDITAR_CORRELATIVO]: {
    id: VENTAS_EDITAR_CORRELATIVO,
    nombre: 'VENTAS_EDITAR_CORRELATIVO'
  },
  [VENTAS_ELIMINAR]: {
    id: VENTAS_ELIMINAR,
    nombre: 'VENTAS_ELIMINAR'
  },
  [VENTAS_ELIMINAR_TODOS]: {
    id: VENTAS_ELIMINAR_TODOS,
    nombre: 'VENTAS_ELIMINAR_TODOS'
  }
}

export const __array = [
  ORDENESCOMPRAS_FIRMAR,
  VENTAS_LISTA_TODOS,
  VENTAS_EDITAR_TODOS,
  ENVIO_SUNAT,
  VENTAS_EDITAR_CORRELATIVO,
  VENTAS_ELIMINAR,
  VENTAS_ELIMINAR_TODOS
]
